export default __webpack_public_path__ + "static/media/Gerhard_Labuscagne.97970fb9.jpeg";